import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { SurveyInviteDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface SurveyInviteFormProps {
  initialValues: SurveyInviteDTO;
  onSubmit: (data: SurveyInviteDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const SurveyInviteForm: React.FC<SurveyInviteFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<SurveyInviteDTO>(initialValues);


  const validationRules: ValidationRules = {
    label: [
      { required: true, message: 'Label is required' }
    ]
  };

  const { errors, validate } = useFormValidation<SurveyInviteDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection
        id={FORM_SECTIONS.basicInfo.id}
        title={FORM_SECTIONS.basicInfo.title}
      >
        <FormField
          id="label"
          label="Label"
          type="text"
          value={formData.label || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Label"
          required={true}
          error={errors.label}
        />

      </FormSection>
    </Form>
  );
};

export default SurveyInviteForm;